import { cn } from "@/lib/utils";

/** Compact bottom sheet shell (FabMenu, hub filter sheets, Deal quick actions). */
export function bottomSheetDockClassName(...extra: Array<string | undefined>) {
  return cn(
    "gap-0 p-0 px-4 pt-2",
    "pb-[max(0.75rem,env(safe-area-inset-bottom))]",
    "rounded-t-2xl border-0",
    ...extra,
  );
}

/** SheetHeader row for filter / docked bottom sheets (matches FabMenu title strip). */
export const bottomSheetFilterTitleClassName =
  "max-[767px]:pt-0 space-y-0 border-b px-0 pb-2 pt-2 text-left";
